module.exports = __webpack_public_path__ + "img/mako-satin_thumbnail_mobile.2ca3dfe5.jpg";